"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.starts-with");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _shopList = require("@/api/shop/shopList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BusinessNotice',
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      cards: [{
        key: 'ts',
        label: '堂食公告'
      }, {
        key: 'zt',
        label: '自提公告'
      }, {
        key: 'wm',
        label: '外卖公告'
      }, {
        key: 'dt',
        label: '大团公告'
      }],
      // 存储每个公告的 iconUrl 相对路径
      iconPaths: {
        ts: '',
        zt: '',
        wm: '',
        dt: ''
      },
      innerNotices: this.ensure(),
      isSyncingFromParent: false,
      resPath: process.env.VUE_APP_COMMENT_IMAGE_URL
    };
  },
  watch: {
    'formData.notices': {
      deep: true,
      immediate: true,
      handler: function handler(newVal, oldVal) {
        var _this = this;
        if (this.isSyncingFromParent) return;
        if (oldVal && JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.isSyncingFromParent = true;
        this.innerNotices = this.ensure();
        // 初始化 iconPaths
        this.initIconPaths();
        this.$nextTick(function () {
          _this.isSyncingFromParent = false;
        });
      }
    },
    innerNotices: {
      deep: true,
      handler: function handler(newVal) {
        var _this2 = this;
        if (this.isSyncingFromParent) return;
        var newNotices = {};
        var keys = ['ts', 'zt', 'wm', 'dt'];
        keys.forEach(function (k) {
          if (newVal[k]) {
            // 处理 dateRange -> date 对象
            var dateObj = {
              start: '',
              end: ''
            };
            if (newVal[k].dateRange && Array.isArray(newVal[k].dateRange) && newVal[k].dateRange.length === 2) {
              dateObj = {
                start: newVal[k].dateRange[0] || '',
                end: newVal[k].dateRange[1] || ''
              };
            }
            newNotices[k] = {
              date: dateObj,
              weeks: newVal[k].weeks || [],
              timeRange: newVal[k].timeRange || {
                start: '',
                end: ''
              },
              title: newVal[k].title || '',
              content: newVal[k].content || '',
              iconUrl: _this2.iconPaths[k] || ''
            };
          }
        });
        var oldNotices = this.formData.notices || {};
        if (JSON.stringify(newNotices) === JSON.stringify(oldNotices)) {
          return;
        }
        this.isSyncingFromParent = true;
        var emitData = _objectSpread({}, this.formData);
        emitData.notices = newNotices;
        this.$emit('notice-change', emitData);
        this.$nextTick(function () {
          _this2.isSyncingFromParent = false;
        });
      }
    }
  },
  methods: {
    /**
     * 初始化 iconPaths：从 formData.notices 中提取已有的 iconUrl 相对路径
     */
    initIconPaths: function initIconPaths() {
      var _this3 = this;
      var keys = ['ts', 'zt', 'wm', 'dt'];
      var notices = this.formData && this.formData.notices || {};
      keys.forEach(function (k) {
        // iconPaths 存储的是相对路径（不含域名前缀）
        if (notices[k] && notices[k].iconUrl) {
          var url = notices[k].iconUrl;
          // 提取相对路径：去掉域名前缀
          if (typeof url === 'string' && url.startsWith('http')) {
            // 从完整URL中提取相对路径
            try {
              var urlObj = new URL(url);
              url = urlObj.pathname;
            } catch (e) {
              // ignore
            }
          }
          _this3.iconPaths[k] = url;
        } else {
          _this3.iconPaths[k] = '';
        }
      });
    },
    /**
     * 获取文件列表（用于 el-upload 显示）
     */
    getFileList: function getFileList(key) {
      var item = this.innerNotices[key];
      if (!item || !item.iconUrl || item.iconUrl.length === 0) return [];
      return item.iconUrl;
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      var isImage = file.type && file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      return false;
    },
    handleExceed: function handleExceed() {
      this.$message.warning('只能上传一张图片，新图片将替换原有图片');
    },
    /**
     * 删除图片：清空 iconPath
     */
    handleRemove: function handleRemove(key) {
      this.iconPaths[key] = '';
      this.innerNotices[key].iconUrl = [];
    },
    handleChange: function handleChange(file, fileList, key) {
      var _this4 = this;
      if (fileList.length > 0) {
        var fileObj = file.raw;
        // 先展示本地预览
        this.innerNotices[key].iconUrl = [{
          name: file.name,
          url: URL.createObjectURL(fileObj)
        }];
        (0, _shopList.uploadImage)(fileObj, '/notice/').then(function (res) {
          var relativePath = res.data;
          _this4.iconPaths[key] = relativePath;
          // 更新预览为服务器路径
          _this4.innerNotices[key].iconUrl = [{
            name: file.name,
            url: (0, _shopList.getImageUrl)(relativePath)
          }];
        }).catch(function () {
          // 上传失败恢复
          _this4.innerNotices[key].iconUrl = [];
          _this4.iconPaths[key] = '';
          _this4.$message.error('公告图片上传失败');
        });
      } else {
        this.innerNotices[key].iconUrl = [];
        this.iconPaths[key] = '';
      }
      return false;
    },
    ensure: function ensure() {
      var _this5 = this;
      var defaults = {
        ts: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        },
        zt: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        },
        wm: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        },
        dt: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        }
      };
      var current = this.formData && this.formData.notices ? this.formData.notices : {};
      var processItem = function processItem(item, name) {
        if (!item) return _objectSpread({}, defaults[name]);
        var result = _objectSpread({}, item);
        if (!result.iconUrl) {
          result.iconUrl = [];
        } else if (typeof result.iconUrl === 'string') {
          if (result.iconUrl) {
            result.iconUrl = [{
              name: name,
              url: _this5.resPath + result.iconUrl
            }];
          } else {
            result.iconUrl = [];
          }
        } else if (!Array.isArray(result.iconUrl)) {
          result.iconUrl = [];
        }
        if (!result.dateRange) {
          if (result.date && (0, _typeof2.default)(result.date) === 'object') {
            var _result$date = result.date,
              start = _result$date.start,
              end = _result$date.end;
            result.dateRange = start && end ? [start, end] : [];
          } else {
            result.dateRange = [];
          }
        }
        if (!result.weeks) result.weeks = [];
        if (!result.timeRange) {
          result.timeRange = result.time || {
            start: '',
            end: ''
          };
        }
        return result;
      };
      return {
        ts: _objectSpread(_objectSpread({}, defaults.ts), processItem(current.ts, 'ts')),
        zt: _objectSpread(_objectSpread({}, defaults.zt), processItem(current.zt, 'zt')),
        wm: _objectSpread(_objectSpread({}, defaults.wm), processItem(current.wm, 'wm')),
        dt: _objectSpread(_objectSpread({}, defaults.dt), processItem(current.dt, 'dt'))
      };
    },
    isWeekAllSelected: function isWeekAllSelected(key) {
      var weeks = this.innerNotices[key].weeks || [];
      return weeks.length === 7;
    },
    isWeekIndeterminate: function isWeekIndeterminate(key) {
      var weeks = this.innerNotices[key].weeks || [];
      return weeks.length > 0 && weeks.length < 7;
    },
    handleWeekSelectAll: function handleWeekSelectAll(key) {
      var weeks = this.innerNotices[key].weeks || [];
      var isAllSelected = weeks.length === 7;
      this.$set(this.innerNotices[key], 'weeks', isAllSelected ? [] : [1, 2, 3, 4, 5, 6, 7]);
    }
  }
};